module.exports = {
  "calendar": "Kalender",
  "day": "dag",
  "dayPeriod": "AM/PM",
  "endDate": "Slutdato",
  "era": "\xE6ra",
  "hour": "time",
  "minute": "minut",
  "month": "m\xE5ned",
  "second": "sekund",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Valgt dato: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Valgt interval: ".concat(args.startDate, " til ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Valgt tidspunkt: ".concat(args.time);
  },
  "startDate": "Startdato",
  "timeZoneName": "tidszone",
  "weekday": "ugedag",
  "year": "\xE5r"
};